import React, { Component } from 'react';
import classnames from 'classnames';
import { bool, func, number, string } from 'prop-types';
import { noop } from 'lodash';
import { I18n } from '@fiverr-private/i18n-react';
import { ReviewsContext } from '../context';
import HelpfulThumb from './HelpfulThumb';
import HelpfulCount from './HelpfulCount';

import './styles.scss';

class Helpful extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selected: false,
        };
        this.onThumbUpSelect = this.onThumbUpSelect.bind(this);
        this.onThumbDownSelect = this.onThumbDownSelect.bind(this);
    }

    static contextType = ReviewsContext;

    displayThankYou() {
        const { selected } = this.state;

        if (!selected) {
            this.setState({ selected: true });
        }
    }

    onThumbUpSelect() {
        const { onThumbUpSelected, thumbUp, thumbDown } = this.props;

        onThumbUpSelected({ thumbUp: !thumbUp, thumbDown });
        this.displayThankYou();
    }

    onThumbDownSelect() {
        const { onThumbDownSelected, thumbDown, thumbUp } = this.props;

        onThumbDownSelected({ thumbDown: !thumbDown, thumbUp });
        this.displayThankYou();
    }

    render() {
        const { thumbUp, thumbDown, helpfulCount, className } = this.props;

        return (
            <div className={classnames('helpful-thumbs', className)}>
                <div className="tbody-6 helpful-text m-r-12">
                    <I18n k="reviews.helpful.helpful" />?
                </div>
                <span className="flex thumb-icons-wrapper">
                    <span className="m-r-12">
                        <HelpfulThumb
                            title={<I18n k="reviews.helpful.yes" />}
                            iconName={HelpfulThumb.ICON_NAME.UP}
                            onSelect={this.onThumbUpSelect}
                            selectedClassName="helpful-thumbs-selected"
                            selected={thumbUp}
                        />
                    </span>
                    <HelpfulThumb
                        title={<I18n k="reviews.helpful.no" />}
                        iconName={HelpfulThumb.ICON_NAME.DOWN}
                        onSelect={this.onThumbDownSelect}
                        selectedClassName="not-helpful-thumbs-selected"
                        selected={thumbDown}
                    />
                </span>
                <span className="flex m-l-12">
                    <HelpfulCount isHelpfulSelected={thumbUp} count={helpfulCount} />
                </span>
            </div>
        );
    }
}

Helpful.propTypes = {
    thumbUp: bool,
    thumbDown: bool,
    onThumbUpSelected: func,
    onThumbDownSelected: func,
    helpfulCount: number,
    className: string,
};

Helpful.defaultProps = {
    thumbUp: false,
    thumbDown: false,
    onThumbUpSelected: noop,
    onThumbDownSelected: noop,
    helpfulCount: 0,
    className: '',
};

export default Helpful;
